import { runDemo } from "../shared/demoRunner";
import { createCellShadingScene } from "./scene";

runDemo({ createScene: createCellShadingScene });
